// styles
import { HeroWrapper } from './Hero.styles';

export function Hero() {
  return (
    <HeroWrapper
      bg={{
        xxlarge: 'images/warehouse/hero/loadsmart-hero-xxlg@2x.jpg',
        large: 'images/warehouse/hero/loadsmart-hero-xxlg@2x.jpg',
        medium: 'images/warehouse/hero/loadsmart-hero-xxlg@2x.jpg',
        small: 'images/warehouse/hero/loadsmart-hero-small@2x.jpg',
      }}
    />
  );
}
